//子级router-view承载
import Center from '@/components/common/center'

//首页控制台
import Home from '@/pages/home/index'

export default [{
  path: 'Home',
  component: Home,
  meta: {
    title: '控制台'
  },
}]



// WEBPACK FOOTER //
// ./src/router/module/home.js